export const title = [
  {
    value: "10",
    desc: "Mr."
  },
  {
    value: "20",
    desc: "Mrs."
  },
  {
    value: "30",
    desc: "Ms."
  },
  {
    value: "270",
    desc: "Dr."
  },
  {
    value: "520",
    desc: "Professor"
  },
  {
    value: "570",
    desc: "Reverend"
  },
  {
    value: "40",
    desc: "Miss"
  },
  {
    value: "350",
    desc: "Lieutenant Colonel"
  },
  {
    value: "530",
    desc: "Rabbi"
  },
  {
    value: "710",
    desc: "The Honorable"
  },
  {
    value: "210",
    desc: "Colonel"
  },
  {
    value: "160",
    desc: "Captain"
  },
  {
    value: "280",
    desc: "Father"
  },
  {
    value: "150",
    desc: "Brother"
  },
  {
    value: "220",
    desc: "Commander"
  },
  {
    value: "70",
    desc: "Ambassador"
  },
  {
    value: "140",
    desc: "Brigadier General"
  },
  {
    value: "470",
    desc: "Pastor"
  },
  {
    value: "660",
    desc: "Sensei"
  },
  {
    value: "320",
    desc: "Judge"
  },
  {
    value: "550",
    desc: "Rear Admiral"
  },
  {
    value: "330",
    desc: "Justice"
  },
  {
    value: "60",
    desc: "Admiral"
  },
  {
    value: "370",
    desc: "Major"
  }
];
